import script from "./commentForAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./commentForAction.vue?vue&type=script&setup=true&lang=ts"

import "./commentForAction.vue?vue&type=style&index=0&id=629ab76a&lang=css"

const __exports__ = script;

export default __exports__